import { Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import Button from "../button/Button";
import { getBtnTxt, openBtnTxt } from "../messages";
import CommonMainList from "./CommonMainList";
import {
  handleOpenAppDetailDialogAndPassDetails,
  handleOpenAppDialog,
} from "../constants";
import CommonVideoImageComponent from "./CommonVideoImageComponent";
import TruncatedTextTooltip from "../TruncatedTextTooltip";

const DynamicBannerTile = ({ collectionData }) => {
  const {
    logo_images,
    asset_url,
    asset_type,
    description,
    display_name,
    is_app_installed,
    shareable_url,
    support_email,
    id,
    thumbnail_url,
  } = collectionData?.[0] || {};

  const [imgSrc, setImgSrc] = useState(logo_images?.original);
  const isVideo = asset_type === "video";

  useEffect(() => {
    if (logo_images) {
      setImgSrc(logo_images?.original);
    }
  }, [logo_images]);

  const handleOpenDetailDialog = useCallback(() => {
    if (is_app_installed) {
      handleOpenAppDialog({
        data: collectionData?.[0],
      });
    } else {
      handleOpenAppDetailDialogAndPassDetails({
        id,
      });
    }
  }, [display_name, description, logo_images, shareable_url, support_email]);

  return (
    <Box className="dynamic-banner-tile-wrapper" padding="0 15px">
      <Box className="dynamic-banner-tile-box">
        <CommonVideoImageComponent
          isVideo={isVideo}
          thumbnail_url={thumbnail_url}
          asset_url={asset_url}
          isFrom="dynamic-banner"
          imgSrc={imgSrc}
          setImgSrc={setImgSrc}
        />

        {/* Overlay text and button */}
        <Box className="banner-text">
          <Box className="right-side-text">
            <Box
              display="flex"
              flexDirection="column"
              className="text-truncate"
            >
              <TruncatedTextTooltip
                textProps={{
                  className: "white-text-only",
                  font: "semibold",
                }}
                textValue={display_name}
                fontSize={16}
              />
              <TruncatedTextTooltip
                textProps={{
                  className: "white-text-only",
                  font: "regular",
                }}
                textValue={description}
                fontSize={12}
              />
            </Box>
          </Box>
          <Button
            label={is_app_installed ? openBtnTxt : getBtnTxt}
            fullWidth={false}
            variant={is_app_installed ? "contained" : "outlined"}
            className="get-button"
            sx={{
              color: is_app_installed ? "#ffffff" : "#003acc",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDetailDialog();
            }}
            textClass="font-12"
          />
        </Box>
      </Box>
      <CommonMainList collectionData={collectionData} />
    </Box>
  );
};

export default DynamicBannerTile;
